<template>
  <v-card flat tile class="elevation-0">
    <v-card color="primary" class="elevation-0 text-left">
      <v-card-title class="px-4 py-4">
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 lg12>
            <h2 class="text-white headline font-weight-bold mt-1">INVITATIONS</h2>
            <p class="text-white subtitle-2 mb-0">Invitations that you have received.</p>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
    <v-layout wrap column>
    <v-flex sm12 md12 class="px-5 pb-4 tabulardata">
      <v-text-field
        class="search-input"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-flex> 
    <div class="text-center mb-4">
      <v-pagination :total-visible="10" :circle="true"  v-model="page" :length="pageCount"></v-pagination>
    </div>
    <v-data-table
      :headers="headers"
      :items="invitationList"
      :search="search"
      class="px-5 pb-4 tabulardata dark-heading text-xs-center"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      @page-count="pageCount = $event"
    >
       <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.name">
            <td class="text-left">{{ item.business }}</td>
            <td class="text-left">{{ item.invited_by }}</td>
            <td class="text-left">{{ item.expires_on }}</td>
            <td class="text-left">{{ item.invite_status }}</td>
            <td class="text-left">
              <v-tooltip top v-if="item.invite_status  == 'pending'">
                <template v-slot:activator="{ on }">
                  <v-btn
                    @click="acceptInvitation(item.invite_token)"
                    slot="activator"
                    fab 
                    small
                    dark 
                    color="primary"
                    v-on="on"
                    :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-3 xs-small' : 'ml-3 xs-small'"
                  >
                    <v-icon dark>check</v-icon>
                  </v-btn>
                  <span>Accept invitation</span>
                </template>
              </v-tooltip>

              <v-tooltip top  v-if="item.invite_status  == 'pending'">
                <template v-slot:activator="{ on }">
                  <v-btn
                    @click="rejectInvitation(item.invite_token)"
                    slot="activator"
                    fab 
                    small
                    dark 
                    color="primary"
                    v-on="on"
                    :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-3 xs-small' : 'ml-3 xs-small'"
                  >
                    <v-icon dark>close</v-icon>
                  </v-btn>
                  <span>Decline invitation</span>
                </template>
              </v-tooltip>
            
            </td>
          </tr>
        </tbody>
      </template>
      <template v-slot:no-data>
        <p class="text-xs-center mb-0">You do not have any inviation.</p>
      </template>
    </v-data-table>
    </v-layout>
  </v-card>
</template>

<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      fieldRequired: [
        v => !!v || 'Field is required',
      ],
      headers: [
        { text: 'Business', value: 'business', sortable: true, class: 'font-weight-bold' },
        { text: 'Invited by', value: 'invited_by', sortable: false, class: 'font-weight-bold' },
        { text: 'Expire on', value: 'expires_on', sortable: false, class: 'font-weight-bold' },
        { text: 'Status', value: 'invite_status', sortable: true, class: 'font-weight-bold' },
        { text: 'Actions', value: 'roles', sortable: false, class: 'font-weight-bold text-left' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      invitationList: 'setting/invitationList',
    }),
  },
  mounted() {
    this.spinner(false);
  },
  methods: {
    /**
     * Accept invitation
     */
    acceptInvitation(token) {
      const url = `${Env.url}/api/v1/users/invite/accept/${token}`;
      this.spinner(true);
      AuthApi.patchApi(url)
        .then((res) => {
          this.getUserInfos();
          this.spinner(false);
          this.snackbar({
            text: res.data.msg,
            timeout: 4000,
            open: true,
          });
        })
        .catch((err) => {
          this.spinner(false);
          this.snackbar({
            text: err.response.data.msg,
            timeout: 4000,
            open: true,
          });
          console.log(err);
        });
    },

     /**
     * Reject invitation
     */
    rejectInvitation(token) {
      const url = `${Env.url}/api/v1/users/invite/decline/${token}`;
      this.spinner(true);
      AuthApi.patchApi(url)
        .then((res) => {
          this.getUserInfos();
          this.spinner(false);
          this.snackbar({
            text: res.data.msg,
            timeout: 4000,
            open: true,
          });
        })
        .catch((err) => {
          this.spinner(false);
          this.snackbar({
            text: err.response.data.msg,
            timeout: 4000,
            open: true,
          });
          console.log(err);
        });
    },

    /**
     * Get all users for business
     */
    getUserInfos() {
      const url = `${Env.url}/api/v1/users/me`;
      AuthApi.getApi(url)
      .then((res) => {
        this.setInvitationList(res.data.invitations);
        this.setBasicInformationList(res.data.user);
      })
      .catch((err) => {
        console.log(err.response.data.msg);
      });
    },

    ...mapActions({
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
      setInvitationList: 'setting/setInvitationList',
      setBasicInformationList: 'setting/setBasicInformationList',
    }),
  },
};
</script>
